import { createRootRoute } from '@tanstack/react-router';
import { RootLayout } from '@/components/layout/RootLayout';

export const Route = createRootRoute({
  component: RootLayout,
});
